<template>
  <div class="content">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <a data-toggle="collapse" href="#filter" role="button" aria-expanded="false" aria-controls="filter">
          {{ $t('app.filter') }}
        </a>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="datatable_filter float-right">
          <div class="row">
            <div class="col">
              <label>
                <select v-model="tableData.length" @change="fetchCalls()" class="form-control form-control-sm">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="collapse" id="filter">
        <div class="card card-body mb-3">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="debt_statuses" class="col-form-label">{{ $t('calls.result_dialog.name') }}</label>
                  <select class="form-control form-control-sm" id="debt_statuses" v-model="filter.debt_status_id">
                    <option selected="true" value="">{{ $t('field.any') }}</option>
                    <option v-for="status in adminListDebtStatuses" :value="status.id" :key="status.id">
                      {{ status.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="call_statuses" class="col-form-label">{{ $t('calls.call_status_name') }}</label>
                  <select class="form-control form-control-sm" id="call_statuses" v-model="filter.status_id">
                    <option selected="true" value="">{{ $t('field.any') }}</option>
                    <option v-for="status in adminListCallStatuses" :value="status.id" :key="status.id">
                      {{ status.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('users.user') }}</label>
                  <select class="form-control form-control-sm" v-model="filter.user_id">
                    <option selected="true" value="">{{ $t('field.any') }}</option>
                    <option v-for="user in adminListUsers" :value="user.id" :key="user.id">
                      {{ user.lastname }} {{ user.firstname }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('field.contragent') }}</label>
                  <select class="form-control form-control-sm" v-model="filter.contragent_id">
                    <option selected="true" value="">{{ $t('field.any') }}</option>
                    <option v-for="contragent in adminListContragents" :value="contragent.id" :key="contragent.id">
                      {{ contragent.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label" for="type_id">{{ $t('calls.type.name') }}</label>
                  <select class="form-control form-control-sm" id="type_id" v-model="filter.type_id">
                    <option selected="true" value="">{{ $t('field.any') }}</option>
                    <option v-for="type in adminListCallTypes" :value="type.id" :key="type.id">
                      {{ type.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('calls.created_at') }}</label>
                  <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="datestart">C</span>
                    </div>
                    <input type="date" class="form-control form-control-sm" aria-label="Small" v-model="filter.period_start_date" aria-describedby="datestart" />
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">{{ $t('calls.created_at') }}</label>
                  <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="dateend">По</span>
                    </div>
                    <input type="date" class="form-control form-control-sm" aria-label="Small" v-model="filter.period_end_date" aria-describedby="dateend" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="text-center">
                  <div class="btn-group" role="group" aria-label="btnGroup1">
                    <button class="btn btn-primary" @click="filterCalls()">
                      <font-awesome-icon icon="search" /> {{ $t('field.find') }}
                    </button>
                    <button class="btn btn-danger" @click="resetForm()">
                      <font-awesome-icon icon="times" /> {{ $t('field.reset') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
    <div class="block block-rounded block-fx-shadow">
      <div class="block-header">
        <h3 class="block-title">{{ $t('calls.contactfaces') }} {{pagination.total ? '(' + pagination.total + ')': '' }}</h3>
      </div>
        <div class="table-responsive">
          <datatable :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" :loading="loadCalls" @sort="sortBy" >
            <tbody>
              <tr v-for="(call, index) in calls" :key="call.id">
                <td>{{index+1}}</td>
                <td>{{call.type.name}}</td>
                <td>{{call.phone ? call.phone.phone: '' }}</td>
                <td>{{call.phone.debtor ? call.phone.debtor.fullname: '' }}</td>
                <td>{{call.user ? `${call.user.firstname} ${call.user.lastname}`: '' }}</td>
                <td>{{call.created_at | datetimeFormat }}</td>
                <td>{{call.status != null ? call.status.name: '' }}</td>
                <td>{{call.result_dialog ? call.result_dialog.name: 'Не выбрано' }}</td>
                <td>{{call.next_contact | dateFormat }}</td>
                <td>{{call.promised_payment.amount}}</td>
                <td>{{call.promised_payment.promised_date | dateFormat }}</td>
                <td>{{call.comment}}</td>
                <td>
                  <button @click.prevent="handleDelete(call.id)" class="btn btn-danger btn-sm " :disabled="isProcessing" >
                    <i class="fa fa-times-circle"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="calls.length == 0 && !loadCalls">
                <td colspan="13" class="text-center">{{ $t('app.empty') }}</td>
              </tr>
            </tbody>
          </datatable>
        </div>
    </div>
    <pagination :pagination="pagination" :offset="4" @paginate="fetchCalls()"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      calls: [],
      columns: [
        { label: '#', name: 'index' },
        { label: this.$t('calls.type.name'), name: 'call_types.name' },
        { label: this.$t('phones.phone'), name: 'phones.phone' },
        { label: this.$t('phones.owner'), name: 'debtors.fullname' },
        { label: this.$t('calls.user_id'), name: 'users.lastname' },
        { label: this.$t('calls.created_at'), name: 'calls.created_at' },
        { label: this.$t('calls.call_status_name'), name: 'call_statuses.name' },
        { label: this.$t('calls.result_dialog'), name: 'debt_statuses.name' },
        { label: this.$t('debts.next_contact_short'), name: 'debts.next_contact' },
        { label: this.$t('calls.promised_amount'), name: 'calls.promised_amount' },
        { label: this.$t('calls.promised_date'), name: 'calls.promised_date' },
        { label: this.$t('app.comment'), name: 'calls.comment' },
        { label: this.$t('app.action'), name: 'action', disableOrder: true },
      ],
      sortKey: 'name',
      sortOrders: {},
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'asc',
      },
      filter: {
        status_id: '',
        contragent_id: '',
        debt_status_id: '',
        next_contact: '',
        type_id: '',
        user_id: '',
        period_start_date: '',
        period_end_date: '',
      },
      pagination: {
        current_page: 1,
      },
      loadCalls: false,
      isProcessing: false,
    };
  },
  computed: {
    ...mapGetters([
      'adminListUsers',
      'adminListContragents',
      'adminListDebtStatuses',
      'adminListCallStatuses',
      'adminListCallTypes',
    ]),
  },
  mounted() {
    this.fetchCalls();
    this.GET_ADMIN_LIST_DEBT_STATUSES();
    this.GET_ADMIN_LIST_USERS();
    this.GET_ADMIN_LIST_CONTRAGENTS();
    this.GET_ADMIN_LIST_CALL_STATUSES();
    this.GET_ADMIN_LIST_CALL_TYPES();
    this.columns.forEach((column) => {
      this.sortOrders[column.name] = -1;
    });
  },
  methods: {
    ...mapActions([
      'GET_ADMIN_LIST_USERS',
      'GET_ADMIN_LIST_CONTRAGENTS',
      'GET_ADMIN_LIST_DEBT_STATUSES',
      'GET_ADMIN_LIST_CALL_STATUSES',
      'GET_ADMIN_LIST_CALL_TYPES',
    ]),

    filterCalls() {
      this.pagination.current_page = 1;
      this.fetchCalls();
    },

    fetchCalls() {
      this.loadCalls = true;
      this.tableData.draw += 1;
      const requests = { ...this.tableData, ...this.filter };
      window.axios.get(`/admin/calls/contactface?page=${this.pagination.current_page}`, { params: requests })
        .then((res) => {
          if (this.tableData.draw === res.data.draw) {
            this.calls = res.data.calls.data;
            this.pagination = this.laraPaginate(res.data.calls);
          } else {
            console.log('failed');
          }
          this.loadCalls = false;
        });
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.column = this.getIndex(this.columns, 'name', key);
      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
      this.fetchCalls();
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deleteCall(id);
        }
      });
    },

    deleteCall(id) {
      this.isProcessing = true;
      window.axios.delete(`/admin/calls/contactface/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchCalls();
          }
          this.isProcessing = false;
        });
    },

    resetForm() {
      this.filter.status_id = '';
      this.filter.contragent_id = '';
      this.filter.debt_status_id = '';
      this.filter.next_contact = '';
      this.filter.type_id = '';
      this.filter.user_id = '';
      this.filter.period_start_date = '';
      this.filter.period_end_date = '';
      this.fetchCalls();
    },
  },
};
</script>
